import { render, staticRenderFns } from "./create.html?vue&type=template&id=355c7d3c&scoped=true&external"
import script from "./create.js?vue&type=script&lang=js&external"
export * from "./create.js?vue&type=script&lang=js&external"
import style0 from "./create.scss?vue&type=style&index=0&id=355c7d3c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355c7d3c",
  null
  
)

export default component.exports